var Curriculog = Curriculog || {};
Curriculog.ProposalForm = Curriculog.ProposalForm || {};


/**
 * The proposal launch dialog
 */
Curriculog.ProposalForm.LaunchErrorDialog = (function ($, _, Backbone, LaunchErrorDialog) {

    LaunchErrorDialog = Curriculog.ShowMeErrorDialog.extend({
        template: 'ProposalForm/Form/LaunchErrorDialog.html',
        title: 'Could Not Launch Proposal',

        message: function() {
            // Due to .error being hidden by default when CUI is enabled, we
            // have to alter the rendered template to set display to block
            var res = $(nunjucks.render(this.template, this));
            res.find('.error').css('display', 'block');
            return res;
        }
    });

    return LaunchErrorDialog;

})($, _, Backbone, Curriculog.ProposalForm.LaunchErrorDialog || {});
